'use strict';

angular.module('app')
    .directive('wishlistTooltip', function (Auth, $compile, $rootScope) {
        return {
            restrict: 'A',
            link: function(scope,element, attr) {
              var template =
                  '<div class="wishlist-message fade-onload">' +
                      '<span class="close" id="close-wishlist">x</span>' +
                      '<p class="title">Save that favourite!</p>' +
                      '<p>With a PADI Travel account, you can favourite dive operators to come back to later on any device or computer</p>' +
                      '<a href="/login/">Log in or sign up</a>' +
                  '</div>',
                  el = $(element);

              if (!$('.wishlist-message').length) {
                  $('body').append($compile(template)(scope));

                  $('#close-wishlist').click(function () {
                      $('.wishlist-message').fadeOut();
                  });
              }

              $rootScope.$on('$locationChangeStart', function() {
                $('.wishlist-message').fadeOut();
              });

              el.click(function () {
                  if (!Auth.isLoggedIn()) {
                      var wishlistPopup = $('.wishlist-message'),
                          wishlistPopupWidth = wishlistPopup.outerWidth(),
                          margin = wishlistPopupWidth/2,
                          windowWidth = window.innerWidth,
                          parentPosition = el.offset().left;

                      if (parentPosition - wishlistPopupWidth < 0 && windowWidth - parentPosition - margin  > 0) {
                          wishlistPopup.fadeIn().css({
                              position: 'absolute',
                              left: parentPosition,
                              top: el.offset().top - wishlistPopup.outerHeight() - 20
                          });
                      } else if (parentPosition - wishlistPopupWidth < 0 && windowWidth - parentPosition - margin  <= 0){
                        wishlistPopup.fadeIn().css({
                            position: 'absolute',
                            left: '10px',
                            top: el.offset().top - wishlistPopup.outerHeight()
                        });
                      } else {
                          wishlistPopup.fadeIn().css({
                              position: 'absolute',
                              left: el.offset().left - wishlistPopupWidth - 20,
                              top: el.offset().top - wishlistPopup.outerHeight() / 2
                          });
                      }
                  }
              });
            }
        };
    });
